/**
 * Lectura (sin verificar firma) del `exp` de un JWT. Solo para UI: saber si la
 * sesión de CoreDB (`webadmin2.corejwt`, dura 4 h) ya venció y avisarlo, en vez
 * de mostrar un 401 crudo (CP-468, Dashboard).
 *
 * Sin imports de runtime para que corra con `node --test`.
 */

/** `exp` en segundos epoch, o null si el token no es un JWT legible. */
export function jwtExp(token: string | null | undefined): number | null {
  const part = (token ?? "").split(".")[1];
  if (!part) return null;
  try {
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(part.length / 4) * 4, "=");
    const exp = JSON.parse(atob(b64))?.exp;
    return typeof exp === "number" ? exp : null;
  } catch {
    return null;
  }
}

/** ¿El token ya venció? Sin token o sin `exp` legible → false (no se puede afirmar). */
export function jwtVencido(token: string | null | undefined, nowMs: number = Date.now()): boolean {
  const exp = jwtExp(token);
  return exp != null && exp * 1000 <= nowMs;
}
